import { useState, useCallback } from 'react';
import { API_URL } from '../constants/api';

export function useDashboard(deviceId, swingHistory) {
  const [showDashboard, setShowDashboard] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(false);
  const [dashboardError, setDashboardError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    if (!deviceId) return;
    setDashboardLoading(true);
    setDashboardError(null);

    try {
      const response = await fetch(`${API_URL}/api/user/${deviceId}/dashboard`, {
        credentials: 'include'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      setDashboardData(data);
      // Show dashboard for returning users with swing history
      if (data.recentSwings && data.recentSwings.length > 0) {
        setShowDashboard(true);
      }
    } catch (error) {
      console.error('Failed to fetch dashboard:', error);
      setDashboardError('Unable to load dashboard. Please try again.');
      // Still show dashboard if we have local swing history
      if (swingHistory && swingHistory.length > 0) {
        setShowDashboard(true);
      }
    } finally {
      setDashboardLoading(false);
    }
  }, [deviceId, swingHistory]);

  const retryDashboard = useCallback(() => {
    setDashboardError(null);
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    showDashboard,
    setShowDashboard,
    dashboardData,
    dashboardLoading,
    dashboardError,
    fetchDashboard,
    retryDashboard,
  };
}
